import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const RightArrowIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      d="M6.40887 10L5.58856 9.19034L8.96569 5.81321H0.219238V4.64133H8.96569L5.58856 1.27486L6.40887 0.454546L11.1816 5.22727L6.40887 10Z"
    />
  </svg>

);

RightArrowIcon.propTypes = {
  color: string.isRequired,
  fillOpacity: number,
  ...helpers.iconDimensionsPropTypes,
};

RightArrowIcon.defaultProps = {
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(12, 10),
};

export default RightArrowIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/righArrow.js